import {
  Flex,
  ComboBox,
  Item,
  View,
  TagGroup,
  Text,
  useAsyncList,
} from "@adobe/react-spectrum";
import React, { useState, useEffect } from "react";
import {
  error as ErrorToast,
  // success as SuccessToast,
} from "@react/react-spectrum/Toast";
import { useOktaAuth } from "@okta/okta-react";
// import { groupsApi } from "../../../api/groupsApi";
import useUserProfile from "../../../context/user-context";
import { SubHistoryCols } from "../../../constants/Columns";
import Table from "../../../components/Common/Table";
import { auditApi } from "../../../api/auditApi";

export default function AuditHistory() {
  const { authState } = useOktaAuth();
  const { user } = useUserProfile();
  const subHistoryCols = SubHistoryCols();

  const searchResultSize = 20;
  const [isSearchLoading, setSearchLoading] = useState("");
  const auditTypes = [{ id: "gtmh", name: "GTMH" }];
  // const [auditTypeField, setAuditTypeField] = useState({
  //   selectedKey: "gtmh",
  //   inputValue: "GTMH",
  // });
  // const auditTypeField = {
  //   selectedKey: "gtmh",
  //   inputValue: "GTMH",
  // };

  // user list combobox + taglist
  const [userList, setUserList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [userField, setUserField] = useState({
    selectedKey: "",
    inputValue: "All",
  });

  const [fetchHistoryRequest, setFetchHistoryRequest] = useState({
    audit_log_id: "",
    users: null,
    page: 0,
    size: searchResultSize,
  });

  const onComboboxInputChange = (value, setFieldFunc) => {
    setFieldFunc((prevState) => ({
      inputValue: value,
      selectedKey: value === "" ? null : prevState.selectedKey,
    }));
  };

  useEffect(() => {
    // set user picker options
    auditApi
      .fetchAuditUsers(
        { component: "HMS-SubManagement" },
        authState.accessToken
      )
      .then((data) => {
        const gtmhGroup = data.results
          .map((x) => ({
            id: x?.userId ? `${x.userId}|${x.userName}` : x?.userName,
            name: x?.userName ? x.userName : x?.userId,
          }))
          .filter((x) => x?.id !== null);
        setUserList(gtmhGroup);
      })
      .catch((error) => {
        ErrorToast(
          error.response?.data?.message || "Failed to get workflows!",
          {
            timeout: 5000,
          }
        );
      });
    // setFetchWfsRequest({ ...fetchWfsRequest, user: user?.userId });
  }, [user]);

  useEffect(() => {
    setFetchHistoryRequest({
      ...fetchHistoryRequest,
      users:
        selectedUsers === []
          ? null
          : selectedUsers.map((x) => x.id.split("|")[0]),
    });
  }, [selectedUsers]);

  const list = useAsyncList({
    initialFilterText: "",
    async load({ filterText, cursor }) {
      let json = {
        results: [],
      };
      const request = cursor || fetchHistoryRequest;

      if (filterText !== "") {
        setSearchLoading("loading");
        json = await auditApi.fetchAuditHistory(request, authState.accessToken);
      }
      const results = json?.results.audit_logs || [];

      setSearchLoading("");
      return {
        items: results,
        cursor:
          results.length < searchResultSize
            ? null
            : {
                ...fetchHistoryRequest,
                page: json?.results.current_page + 1,
              },
      };
    },
    getKey: (item) => item?.id,
  });

  useEffect(() => {
    list.setFilterText(fetchHistoryRequest);
  }, [fetchHistoryRequest]);

  const renderCell = (colKey, row) => {
    let cellVal = row[colKey];
    if (colKey === "field_name") cellVal = row.change_log.field_name;
    if (colKey === "old_value") cellVal = row.change_log.old_value;
    if (colKey === "new_value") cellVal = row.change_log.new_value;
    if (colKey === "operation") cellVal = row.meta_data.operation;
    if (colKey === "user") {
      const userName = userList.find(
        (x) => x.id.split("|")[0] === row.user
      )?.name;
      cellVal = userName === undefined ? row.user : userName;
    }
    return (
      <span // eslint-disable-line jsx-a11y/no-static-element-interactions
        style={{
          cursor: "text",
          WebkitUserSelect: "text",
        }}
        onPointerDown={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <Text>{cellVal}</Text>
      </span>
    );
  };

  return (
    <>
      {/* <LoadingDialog isOpen={isPageLoading} /> */}
      <Flex margin="size-300" gap="size-125" direction="column" width="90%">
        <Flex>
          <Flex gap="size-150" direction="column">
            <Flex gap="size-150">
              <Flex direction="column">
                <ComboBox
                  label="Type"
                  defaultItems={auditTypes}
                  defaultSelectedKey={auditTypes[0].id}
                  // selectedKey={auditTypeField.selectedKey}
                  // inputValue={auditTypeField.inputValue}
                  width="150px"
                >
                  {(item) => <Item>{item.name}</Item>}
                </ComboBox>
              </Flex>
              <Flex direction="column">
                <ComboBox
                  label="User"
                  defaultItems={userList}
                  selectedKey={userField.selectedKey}
                  inputValue={userField.inputValue}
                  onSelectionChange={(val) => {
                    if (val) {
                      setSelectedUsers([
                        ...selectedUsers,
                        userList.find((type) => type.id === val),
                      ]);
                      setUserList(userList.filter((type) => type.id !== val));
                      setUserField({
                        ...userField,
                        inputValue: "",
                      });
                    }
                  }}
                  onInputChange={(val) => {
                    onComboboxInputChange(val, setUserField);
                  }}
                  width="200px"
                >
                  {(item) => <Item>{item.name}</Item>}
                </ComboBox>
                {selectedUsers.length > 0 && (
                  <View maxWidth="200px">
                    <TagGroup
                      onRemove={(val) => {
                        const selectedId = val.values().next().value;
                        setUserList([
                          ...userList,
                          selectedUsers.find((type) => type.id === selectedId),
                        ]);
                        setSelectedUsers(
                          selectedUsers.filter((type) => type.id !== selectedId)
                        );
                        setUserField({
                          ...userField,
                          inputValue: selectedUsers.length === 1 ? "All" : "",
                        });
                      }}
                      items={selectedUsers}
                      aria-label="Selected"
                      allowsRemoving
                    >
                      {(item) => (
                        <Item key={item.id} textValue={item.name}>
                          <Text>{item.name}</Text>
                        </Item>
                      )}
                    </TagGroup>
                  </View>
                )}
              </Flex>
              {/* <Flex direction="column">
                <ComboBox
                  label="Status"
                  defaultItems={wfStatus}
                  selectedKey={wfStatusField.selectedKey}
                  inputValue={wfStatusField.inputValue}
                  onSelectionChange={(val) => {
                    if (val) {
                      setSelectedWfStatus([
                        ...selectedWfStatus,
                        wfStatus.find((type) => type.id === val),
                      ]);
                      setWfStatus(
                        wfStatus.filter((type) => type.id !== val)
                      );
                      setWfStatusField({
                        ...wfStatusField,
                        inputValue: "",
                      });
                    }
                  }}
                  onInputChange={(val) =>
                    onComboboxInputChange(val, setWfStatusField)
                  }
                  width="150px"
                >
                  {(item) => <Item>{item.name}</Item>}
                </ComboBox>
                {selectedWfStatus.length > 0 && (
                  <View maxWidth="150px">
                    <TagGroup
                      onRemove={(val) => {
                        const selectedId = val.values().next().value;
                        setWfStatus([
                          ...wfStatus,
                          selectedWfStatus.find(
                            (type) => type.id === selectedId
                          ),
                        ]);
                        setSelectedWfStatus(
                          selectedWfStatus.filter(
                            (type) => type.id !== selectedId
                          )
                        );
                        setWfStatusField({
                          ...wfStatusField,
                          inputValue:
                            selectedWfStatus.length === 1 ? "All" : "",
                        });
                      }}
                      items={selectedWfStatus}
                      aria-label="Selected"
                      allowsRemoving
                    >
                      {(item) => (
                        <Item key={item.id} textValue={item.name}>
                          <Text>{item.name}</Text>
                        </Item>
                      )}
                    </TagGroup>
                  </View>
                )}
              </Flex> */}
              {/* <SearchField
                label="Search Wf Id"
                placeholder="Search by wf id"
                value={searchedWfId}
                onChange={setSearchedWfId}
                onSubmit={(val) => {
                  setFetchWfsRequest({ ...fetchWfsRequest, wf_id: val });
                }}
                onClear={() => {
                  setSearchedWfId("");
                  setFetchWfsRequest({ ...fetchWfsRequest, wf_id: "" });
                }}
                width="200px"
              /> */}
              {/* <Flex marginTop="25px">
                <TooltipTrigger>
                  <ActionButton
                    isQuiet
                    onPress={() =>
                      setFetchWfsRequest({
                        ...fetchWfsRequest,
                        wf_id: searchedWfId,
                      })
                    }
                  >
                    <Refresh />
                  </ActionButton>
                  <Tooltip>Refresh Workflows</Tooltip>
                </TooltipTrigger>
              </Flex> */}
            </Flex>
          </Flex>
        </Flex>
        <Flex
          marginTop="size-50"
          UNSAFE_style={{
            backgroundColor: "white",
            borderRadius: "0.5rem",
          }}
          direction="row"
          height={list.items > 0 ? "static-size-7000" : "static-size-6000"}
        >
          <Table
            columns={subHistoryCols}
            rows={list.items.map((item, index) => ({
              ...item,
              id: index,
            }))}
            loadingState={
              isSearchLoading !== "" ? isSearchLoading : list.loadingState
            }
            onLoadMore={list.loadMore}
            renderCell={renderCell}
            selectionMode="none"
            density="compact"
          />
        </Flex>
      </Flex>
    </>
  );
}
